import { render, staticRenderFns } from "./SendCollectiveReqModal.vue?vue&type=template&id=3977cede&"
import script from "./SendCollectiveReqModal.vue?vue&type=script&lang=js&"
export * from "./SendCollectiveReqModal.vue?vue&type=script&lang=js&"
import style0 from "./SendCollectiveReqModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports